var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpShoesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#A3D7FF;}\r\n\t.st2{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160,320l-85,85c-6.1,6.1-6.3,16-0.3,22.3l491.9,522.7c6,6.4,14.5,10.1,23.3,10.1H944c8.8,0,16-7.2,16-16V832 H640L160,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.5,960H72c-4.4,0-8-3.6-8-8v-80c0-4.4,3.6-8,8-8h235.5c8,0,15.8,3,21.7,8.5l79.8,73.6 c3.2,3,3.5,8.1,0.5,11.3C407.9,959.1,405.8,960,403.5,960z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M832,576L832,576c-45.7,0-88-24.4-110.9-64H520c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h184v-64H520 c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h184v-32c0-17.7-14.3-32-32-32l0,0c-88.4,0-160-71.6-160-160l0,0c0-17.7-14.3-32-32-32h-5.7 c-42.4,0-83.1,16.9-113.1,46.9L200,272l480,488h280v-56C960,633.3,902.7,576,832,576z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpShoesActive);
export default __webpack_public_path__ + "static/media/hp_shoes_active.f1458edb60dece7524f0c6d4abdb43bd.svg";
export { ForwardRef as ReactComponent };